import React from 'react';
import { Link } from 'react-router-dom';
import { BanIcon, CheckIcon } from 'react-open-iconic-svg';
import { formatDate } from 'services/utils'
import { showClasses } from 'services/constants'
import CollapsibleFieldset from 'components/CollapsibleFieldset';


export default function DogsByFCIGroup(props) {
  const { dogs, breeds, group } = props
  const groupBreeds = breeds.filter(breed => breed.fci_group === group)
  return (
    <div className="dogs-by-breeds mt-3">
      {groupBreeds.map(breed => {
        const breedDogs = dogs.filter(dog => dog.breed_id === breed.id);
        return (
          <CollapsibleFieldset 
             key={breed.id}
             title={breed.name + ' ('+breedDogs.length+')'} 
             open={props.open}
             className="m-3">
            <DogsByBreed dogs={breedDogs} open={props.open} />
          </CollapsibleFieldset>
        );
      })}
    </div>
  );
}

function DogsByBreed(props) {
  const females = props.dogs.filter(dog => dog.sex === 'female');
  const males = props.dogs.filter(dog => dog.sex === 'male');
  return (
    <div className="p-3">
      {males.length ? (
        <CollapsibleFieldset open={props.open} title={'Кобели (' + males.length + ')'}>
          <DogsByClasses dogs={males} open={props.open}/>
        </CollapsibleFieldset>
        ) : null
      }
      {females.length ? (
        <CollapsibleFieldset open={props.open} title={'Суки (' + females.length + ')'}>
          <DogsByClasses dogs={females} open={props.open} />
        </CollapsibleFieldset>
        ) : null
      }
    </div>
  );
}

function DogsByClasses(props) {
  const dogs = props.dogs;
  return showClasses.map(showClass => {
    if (!showClass.id) return null;
    const classDogs = dogs.filter(dog => dog.class_in_show === showClass.id);
    if (!classDogs.length) return null;
    return (
      <CollapsibleFieldset 
        open={props.open}
        className="m-2"
        key={showClass.id} 
        title={showClass.name + ' (' + classDogs.length + ')'}>
        {classDogs.map(dog => <DogInfo key={dog.id} dog={dog} />)}
      </CollapsibleFieldset>
    );
  }).filter(item => item);
}


function DogInfo(props) {
  const dog = props.dog;

  return (
    <div className="dog-info pl-2 m-1 row">
      <Link to={'/dogs/'+dog.id} className="dog-name col-3">{dog.name}</Link>
      <span className="dog-color col-1"> | {dog.color} </span>
      <span className="dog-pedigree col-2"> | {dog.pedigree} </span>
      <span className="dog-dob col-2"> | {formatDate(dog.date_of_birth)} </span>
      <span className="dog-dob col-2"> | {dog.titles} </span>
      <span className="dog-ticket col-1" title={dog.ticket_sent ? 'талон выслан' : 'талон не выслан'}>
       | { dog.ticket_sent ? 
        <CheckIcon className="icon success" viewBox="0 0 8 8" alt="талон выслан" /> : 
        <BanIcon className="icon fail" viewBox="0 0 8 8" alt="талон не выслан" /> 
       } 
      </span>
      <span className="dog-dob col-1"> | #{dog.catalog_number} </span>
    </div>
  );
} 